import { render, staticRenderFns } from "./groupNick.vue?vue&type=template&id=644e3c32&scoped=true&"
import script from "./groupNick.vue?vue&type=script&lang=js&"
export * from "./groupNick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e3c32",
  null
  
)

export default component.exports